import React from 'react';
import { Box, Card, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

/**
 * Consistent panel wrapper with glassmorphism styling
 */
export default function Panel({ 
  title, 
  icon, 
  children, 
  onClose,
  sx = {},
  headerSx = {},
  contentSx = {} 
}) {
  return (
    <Card
      sx={{
        borderRadius: (theme) => theme.shape.borderRadius * 2,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        background: (theme) => 
          `linear-gradient(to bottom right, ${theme.palette.background.paper}AA, ${theme.palette.background.paper}55)`,
        backdropFilter: 'blur(8px)',
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        // Remove default Card spacing differences across browsers
        boxSizing: 'border-box',
        ...sx
      }}
    >
      {(title || onClose) && (
        <Box
          sx={{
            px: 2,
            // Fixed header height ensures alignment with siblings
            minHeight: 48,
            height: 48,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            background: (theme) => 
              `linear-gradient(135deg, ${theme.palette.background.paper}66, transparent)`,
            flexShrink: 0,
            ...headerSx
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
            {icon}
            {title && (
              <Typography variant="subtitle2" fontWeight={600} lineHeight={1}>
                {title}
              </Typography>
            )}
          </Box>
          {onClose && (
            <IconButton 
              size="small" 
              onClick={onClose}
              sx={{ opacity: 0.7, '&:hover': { opacity: 1 } }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      )}
      <Box 
        sx={{ 
          flex: 1, 
            // Standard internal spacing; avoid extra top padding mismatch
          p: 2,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          ...contentSx 
        }}
      >
        {children}
      </Box>
    </Card>
  );
}